export default{
    lang:"cn",
    fontFamily:"cn-font-family",
    fontFamilyTitle:"cn-font-family-title",
    requestLang:"zh_TW",
    type: "cn"
}